import { z } from "zod/v4";
import { createEndpointBase } from "./core";

const setup = createEndpointBase("setup");

export const setupEndpoints = {
  setupValidateToken: setup({
    method: "POST",
    path: "validate-token",
    request: z.object({ token: z.string() }),
    response: z.object({ valid: z.boolean() }),
    description: "Validates a one-time setup token.",
  }),
  setupCreateUser: setup({
    method: "POST",
    path: "create-user",
    request: z.object({
      token: z.string(),
      username: z.string(),
      password: z.string(),
    }),
    response: z.object({ success: z.boolean() }),
    description: "Creates the first administrator account using a valid setup token.",
  }),
  setupRequestContact: setup({
    method: "POST",
    path: "request-contact",
    request: z.any(),
    response: z.object({ success: z.boolean() }),
    description: "Requests contact from Azure.",
  }),
} as const;
